var _rect, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DZone4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1166,
    y: 361,
    width: 103.87,
    height: 23.51,
    rx: 11.755,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1188.75 378.255V377.232L1195.02 367.869H1188.68V366.619H1196.7V367.641L1190.43 377.005H1196.77V378.255H1188.75ZM1208.89 372.437C1208.89 373.664 1208.67 374.725 1208.22 375.619C1207.78 376.513 1207.17 377.202 1206.4 377.687C1205.63 378.172 1204.74 378.414 1203.75 378.414C1202.76 378.414 1201.88 378.172 1201.1 377.687C1200.33 377.202 1199.72 376.513 1199.28 375.619C1198.84 374.725 1198.61 373.664 1198.61 372.437C1198.61 371.21 1198.84 370.149 1199.28 369.255C1199.72 368.361 1200.33 367.672 1201.1 367.187C1201.88 366.702 1202.76 366.46 1203.75 366.46C1204.74 366.46 1205.63 366.702 1206.4 367.187C1207.17 367.672 1207.78 368.361 1208.22 369.255C1208.67 370.149 1208.89 371.21 1208.89 372.437ZM1207.52 372.437C1207.52 371.429 1207.36 370.579 1207.02 369.886C1206.68 369.193 1206.23 368.668 1205.66 368.312C1205.09 367.956 1204.46 367.778 1203.75 367.778C1203.05 367.778 1202.41 367.956 1201.84 368.312C1201.27 368.668 1200.82 369.193 1200.48 369.886C1200.15 370.579 1199.98 371.429 1199.98 372.437C1199.98 373.444 1200.15 374.295 1200.48 374.988C1200.82 375.681 1201.27 376.206 1201.84 376.562C1202.41 376.918 1203.05 377.096 1203.75 377.096C1204.46 377.096 1205.09 376.918 1205.66 376.562C1206.23 376.206 1206.68 375.681 1207.02 374.988C1207.36 374.295 1207.52 373.444 1207.52 372.437ZM1220.96 366.619V378.255H1219.6L1213.26 369.119H1213.15V378.255H1211.74V366.619H1213.1L1219.46 375.778H1219.58V366.619H1220.96ZM1224.26 378.255V366.619H1231.29V367.869H1225.67V371.8H1230.92V373.05H1225.67V377.005H1231.38V378.255H1224.26ZM1238.81 375.869V374.71L1243.92 366.619H1244.76V368.414H1244.2L1240.33 374.528V374.619H1247.22V375.869H1238.81ZM1244.29 378.255V375.516V374.977V366.619H1245.63V378.255H1244.29Z",
    fill: "#2E3838"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1217.94,
    cy: 451.51,
    r: 25.3,
    stroke: "white",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1217.94,
    cy: 451.51,
    r: 38,
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1217.94,
    cy: 451.51,
    r: 13.65,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DZone4);
export default __webpack_public_path__ + "static/media/3d_zone_4.a9114126a53684c8b3b1c1885010bb1b.svg";
export { ForwardRef as ReactComponent };